export default __webpack_public_path__ + "static/media/testimonial-2.acb13c0f.jpg";